import React from 'react';
import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  ContentLayout,
  ColumnLayout,
  Flashbar,
  Header,
  HelpPanel,
  Link,
  SpaceBetween,
  SplitPanel,
  Box,
  StatusIndicator,
  Grid
} from '@cloudscape-design/components';
import ModernizationOverview from './widgets/modernizationoverview';
import ServiceHealth from './widgets/servicehealth';
import ProjectStatusSummary from './widgets/projectstatussummary';
import TimelineView from './widgets/timelineview';
import AIEffectivenessView from './widgets/aieffectiveness';
import TeamProductivityView from './widgets/teamproductivity';
import QuickActionsView from './widgets/quickactions';
import CostSavingsEstimator from './widgets/costsavingsestimator';
import TechnicalDebtAnalyzer from './widgets/technicaldebtanalyzer';

const LOCALE = 'en';

export function DashboardPage() {
  return (
        <ContentLayout
        header={
            <Header variant="h1" info={<Link variant="info">Info</Link>}>
            Dashboard
            </Header>
        }
        >

            <Grid
            gridDefinition={[
                { colspan: { l: 8, m: 8, default: 12 } },
                { colspan: { l: 4, m: 4, default: 12 } },
                { colspan: { default: 12 } },
                { colspan: { default: 12 } },
                { colspan: { default: 12 } },
                { colspan: { default: 12 } },
                { colspan: { default: 12 } },
                { colspan: { l: 6, m: 6, default: 12 } },
                { colspan: { l: 6, m: 6, default: 12 } },
            ]}
            >
                <ModernizationOverview></ModernizationOverview>
                <ServiceHealth></ServiceHealth>
                <QuickActionsView></QuickActionsView>
                <ProjectStatusSummary></ProjectStatusSummary>
                <AIEffectivenessView></AIEffectivenessView>
                <TeamProductivityView></TeamProductivityView>
                <TimelineView></TimelineView>
                <CostSavingsEstimator></CostSavingsEstimator>
                <TechnicalDebtAnalyzer></TechnicalDebtAnalyzer>
            </Grid>

            
        </ContentLayout>
  );
}
